export function fmtTime(t: number | null): string {
  if (t === null || Number.isNaN(t)) return '—'
  const h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = Math.floor(t % 60)
  const mm = h ? String(m).padStart(2, '0') : String(m).padStart(2, '0')
  return `${h ? h + ':' : ''}${mm}:${String(s).padStart(2, '0')}`
}

/** Short label for a transcript id like `t03-pm-fintech` → `t03`. */
export function shortId(id: string): string {
  const m = /^([a-z]\d{1,3})\b/i.exec(id)
  return m ? m[1] : id.slice(0, 6)
}

export function fmtDate(iso: string): string {
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
}

/** Deterministic hue per speaker so the gutter is scannable. */
export function speakerHue(name: string): number {
  let h = 0
  for (const c of name) h = (h * 31 + c.charCodeAt(0)) % 360
  return h
}

export const REASON_HELP: Record<string, string> = {
  'no citation': 'The model made this claim without pointing at any line.',
  'line not found': 'The line id it cited does not exist in the corpus.',
  'quote not in line': 'The words it quoted are not verbatim in that line.',
  'single source': 'Backed by real quotes, but from fewer transcripts than a theme needs (2).',
}
